/* eslint-disable no-param-reassign */
import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import usersApi from '@/api/users'

export default {
  state: {
    users: [],
    pages: 0,
    currentPage: 1,
    paginationPageSize: 20,
    total: 0
  },
  mutations: {
    [MUTATION_TYPE.setUsers]: (state, users) => {
      state.users = users
    },
    [MUTATION_TYPE.setCurrentPage]: (state, page) => {
      state.currentPage = page
    },
    [MUTATION_TYPE.setCurrentPageSize]: (state, pageSize) => {
      state.paginationPageSize = pageSize
    },
    [MUTATION_TYPE.setTotal]: (state, total) => {
      state.total = total
    },
    [MUTATION_TYPE.setPages]: (state, pages) => {
      state.pages = pages
    },
    [MUTATION_TYPE.setUsersIsActive]: (state, isActive) => {
      state.users.forEach((user) => { user.isActive = isActive })
    }
  },
  actions: {
    [ACTION_TYPE.fetchUsers]: ({ commit, state }, payload) => new Promise((resolve, reject) => {
      if (payload.chats) {
        usersApi.getContacts(payload.filters, payload.sorting,
          state.currentPage, state.paginationPageSize)
          .then(({ data }) => {
            commit(MUTATION_TYPE.setUsers, data.docs)
            commit(MUTATION_TYPE.setPages, data.pages)
            commit(MUTATION_TYPE.setTotal, data.total)
            resolve()
          }).catch((error) => {
            reject(error)
          })
      } else {
        usersApi.getUsers(payload.filters, payload.sorting,
          state.currentPage, state.paginationPageSize)
          .then(({ data }) => {
            commit(MUTATION_TYPE.setUsers, data.docs)
            commit(MUTATION_TYPE.setPages, data.pages)
            commit(MUTATION_TYPE.setTotal, data.total)
            resolve()
          }).catch((error) => {
            reject(error)
          })
      }
    }),
    [ACTION_TYPE.changePage]: ({ commit }, page) => {
      commit(MUTATION_TYPE.setCurrentPage, page)
    },
    [ACTION_TYPE.changePageSize]: ({ commit }, pageSize) => {
      commit(MUTATION_TYPE.setCurrentPageSize, pageSize)
    },
    // eslint-disable-next-line max-len
    [ACTION_TYPE.translateStudents]: (_, StudentsId) => new Promise((resolve) => {
      usersApi.translateStudents(StudentsId).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        resolve(error.response)
      })
    }),
    // eslint-disable-next-line max-len
    [ACTION_TYPE.undoTranslateStudents]: (_, StudentsId) => new Promise((resolve) => {
      usersApi.undoTranslateStudents(StudentsId).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        resolve(error.response)
      })
    }),
    // eslint-disable-next-line max-len
    [ACTION_TYPE.removeStudents]: (_, StudentsId) => new Promise((resolve) => {
      usersApi.removeStudents(StudentsId).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        resolve(error.response)
      })
    })
  },
  getters: {
    [GETTER_TYPE.getUsers]: (state) => state.users,

    [GETTER_TYPE.getUser]: (state) => (userId) => {
      const user = state.users.filter((el) => el.id === userId)
      if (user) {
        return user[0]
      }
      return null
    },

    [GETTER_TYPE.getPages]: (state) => state.pages,

    [GETTER_TYPE.getCurrentPage]: (state) => state.currentPage,

    [GETTER_TYPE.getPaginationPageSize]: (state) => state.paginationPageSize,

    [GETTER_TYPE.getTotal]: (state) => state.total
  }
}
